export enum PhoneNumberType {
  Home = '1',
  Office = '2',
  Fax = '3',
  Mobile = '4'
}
